/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import Fragment from 'react-dot-fragment';
import BannerLayout from "../../../layouts/banner";

import Image from '../../../../../containers/assets/pf34.png';

const MarketShareStep5 = () => (
  <BannerLayout
    section="FEEDBACK"
    subSection="MARKET SHARE"
    hideAlert={true}
    subTitle="Understand the Customer"
    paragraph2={(
      <Fragment>
        Sergey Brin, the co-founder of Google, learned the hard way when his team launched one of the
        biggest and very public product flops: the Google Glass. The product was intended for mass
        consumers but insufficient market research led to low interest and adoption. Google ultimately
        decided to pivot from the mass consumer
        market. <a href="https://medium.com/nyc-design/the-assumptions-that-led-to-failures-of-google-glass-8b40a07cfa1e#:~:text=Unfortunately%2C%20the%20Glass%20failed%20because,enough%20to%20appeal%20to%20everyone." rel="noreferrer" target="_blank">Learn More</a>
      </Fragment>
    )}
    visual={(
      <img src={Image} alt="preview" />
    )}
    visualProps={{
      noBorder: true,
      noBackground: true,
    }}
  />
);

export default MarketShareStep5;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/feedback/market-share/step5.js